import CryptoJS from 'crypto-js'

export const encryption = (param) => {
  const { key, value } = param
  const iv = CryptoJS.enc.Latin1.parse(key)
  const encrypted = CryptoJS.AES.encrypt(value, iv,
    { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding })
  return encrypted.toString()
}

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len, date) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, len || 4)
  if (date) random = random + Date.now()
  return random
}

// 验证码倒计时时间
export const CountDown = 60

